var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.$t("NewOffer.title")))]),_vm._v(" "),_c('div',{staticClass:"card card-transparent"},[_c('div',{staticClass:"card-block"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 offset-md-1"},[(_vm.dataReady)?_c('offer-form',{attrs:{"offerId":null}}):_vm._e()],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7266763e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/offers/NewOffer.vue
// module id = EBCP
// module chunks = 1